<div class="px-5">
  <h1>Historial de Precios</h1>
  <app-admin-table
    #table
    [mapHeader]="mapHeader"
    [queryset]="data$"
  ></app-admin-table>
</div>
